import { render, staticRenderFns } from "./AscMxRecUpcomingFlightsWrapper.vue?vue&type=template&id=1b23c042&"
import script from "./AscMxRecUpcomingFlightsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecUpcomingFlightsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecUpcomingFlightsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports